<app-nav titulo="Detalles del servicio" descripcion="Aqui podrá ver toda la información sobre el servicio seleccionado.">
    <div class="service-details">
        <app-service-details-content [service]="service" *ngIf="service"></app-service-details-content>
    </div>
</app-nav>
